import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="WebUI Settings">
        <EuiText>
          <p>
            Web User Interface Settings.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

